<template>
    <div>
        <div v-if="message != null && message.length > 0" class="tempdata alert alert-primary Message-Info Info Message-Info">
            <span v-html="message"></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Message',
        computed: {
            message() {
                return this.$store.state.message;
            }
        },
        mounted() {
            this.$store.dispatch("getMessage");
        }
    };
</script>

